export class Hubspot {
  constructor () {
    this.createForm = this.createForm.bind(this)

    this.utils = document.createElement('script')
    this.utils.src = 'https://js.hsforms.net/forms/v2.js'
    document.body.appendChild(this.utils)

    this.promise = new Promise(resolve => {
      this.utils.addEventListener("load", resolve)
    })
  }

  createForm (code) {
    const request = document.createElement('script')
    document.body.appendChild(request)
    request.innerHTML = code
  }
}

export const hubspot = new Hubspot()